import { useState } from 'react';

export class UserSessionInfo {
	id: string = "default";
	name: string = "default";
	email: string = "default";
	phone: string = "default";
};

export class UserSessionData {
	loggedIn: boolean = false;
	currentUser?: UserSessionInfo = undefined;
}

export const UserSessionDefaults = new UserSessionData();

export const useUserSessionStorage = (initialValue: UserSessionData): [UserSessionData, (val: UserSessionData)=>void] => {
	const key = "cytrusted.frontend.user";
	const [item, setInnerValue] = useState(() => {
		try {
			const item = window.sessionStorage.getItem(key);
			if (item) {
				return JSON.parse(item) as UserSessionData;
			} else {
				window.sessionStorage.setItem(key, JSON.stringify(initialValue));
				return initialValue;
			}
		} catch (error) {
			window.sessionStorage.setItem(key, JSON.stringify(initialValue));
			return initialValue;
		}
	});

	const setValue = (value: UserSessionData) => {
		try {
			setInnerValue(value);
			window.sessionStorage.setItem(key, JSON.stringify(value));
		} catch (e) {
			console.log(e);
		}
	};

	return [item, setValue];
}
